import React, { Component } from 'react';
import { Row, Col, Button, Input } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import { Field } from 'redux-form';
import ReactDOM from 'react-dom';

import ConfirmActionModal from '../Common/confirmActionModal';
import { DisabledInputField, InputField } from '../Common/inputField';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from '../../actions/root_url';

const isEcity = ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || ROOT_API_URL === 'https://ctstage-scm.truckxi.com/api/';


class SetWeightModal extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      needsDelete: false,
      rowsToDelete: 0,
      finished: false,
      oldLoaded: 0,
      changed: false,
      weights: {
        rows: [],
        sortColumn: null,
        sortDirection: null,
      },
      changeStyle: false,
      confirmOpen: false,
      case: 'zeroWeight',
      selectedWeightIdx: 1,
      selectedWeight: '',
    };
  }

  componentDidMount() {
    if (this.props.invoice) {
      const rows = [];
      this.props.currentWeights.map((weight) => {
        rows.push({ Weight: weight });
      });

      const oldLoaded = rows.length;
      if (rows.length < this.props.totalLoaded) {
        const temp = rows.length;
        for (var i = 0; i < (this.props.totalLoaded - temp); i++) {
          rows.push({ Weight: 0 });
        }
      }
      const weights = { ...this.state.weights, rows };

      if ((parseFloat(this.props.totalLoaded) < rows.length)) {
        const rowsToDelete = rows.length - this.props.totalLoaded;
        this.setState({ needsDelete: true, rowsToDelete, oldLoaded });
      } else {
        this.setState({ needsDelete: false, oldLoaded });
      }
      this.setState({ weights });
    } else {
      this.props.fetchSalesOrderLineWeights(this.props.rowChosen);
    }
    ReactDOM.findDOMNode(this.refs['TotalWeight'].getRenderedComponent().myInput.refs.input).focus();
  }

  componentWillReceiveProps(nextProps) {
    if ((parseFloat(nextProps.totalLoaded) < nextProps.salesOrderLineWeights.length) && !this.state.finished){
      const rowsToDelete = nextProps.salesOrderLineWeights.length - nextProps.totalLoaded;
      this.setState({ needsDelete: true, rowsToDelete });
    } else {
      this.setState({ needsDelete: false });
    }
    if (nextProps.totalWeight !== this.props.totalWeight) {
      let avgWeight = (parseFloat(nextProps.totalWeight) || 0) / (parseFloat(this.state.weights.rows.length) || 1);
      avgWeight = avgWeight.toFixed(4);
      this.state.weights.rows.map((r) => {
        r.Weight = avgWeight;
      });
    }
    if (nextProps.salesOrderLineWeights && nextProps.salesOrderLineWeights !== this.props.salesOrderLineWeights) {
      let tempWeights = [];

      nextProps.salesOrderLineWeights.map((weight) => {
        tempWeights.push({ Weight: weight });
      });

      if (nextProps.salesOrderLineWeights.length >= this.props.totalLoaded) {
        const newWeights = tempWeights; // .splice(0, parseInt(this.props.totalLoaded));
        const weights = { ...this.state.weights, rows: newWeights };
        this.setState({ weights });
      } else {
        const temp = tempWeights.length;
        for (var i = 0; i < (this.props.totalLoaded - temp); i++) {
          tempWeights.push({ 'Weight': 0 });
        }
        const weights = { ...this.state.weights, rows: tempWeights };
        this.setState({ weights });
      }
    }
  }

  componentWillUnmount() {
    if (!this.state.changed) {
      this.props.keepLoaded(this.state.oldLoaded);
    }
    this.props.clearSalesOrderLineWeights();
  }

  fillWithLastValue() {
    let index = 0;
    const newWeights = { ...this.state.weights };

    for (var i = 0; i < this.state.weights.rows.length; i++) {
      if (this.state.weights.rows[i].Weight === 0) {
        index = i;
        break;
      }
    }

    if (index > 0) {
      const fillValue = this.state.weights.rows[index - 1].Weight;

      for (var i = index; i < this.state.weights.rows.length; i++) {
        newWeights.rows[i].Weight = fillValue;
      }
      this.setState({ weights: newWeights });
    }
  }

  clearAllValues() {
    const newWeights = [...this.state.weights.rows];
    newWeights.map((row) => {
      row.Weight = 0;
    });

    const weights = { ...this.state.weights, rows: newWeights }
    this.setState({ weights })
  }

  handleKeyPress = (event) => {
    if (event.charCode === 13 && this.state.selectedWeight) {
      event.preventDefault();
      // ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
      const weights = { ...this.state.weights };

      if (this.state.selectedWeightIdx === this.state.weights.rows.length){
        weights.rows[this.state.selectedWeightIdx - 1].Weight = this.state.selectedWeight;
        this.setState({ selectedWeight: '', selectedWeightIdx: 0, weights})
      } else if (this.state.selectedWeightIdx) {
        weights.rows[this.state.selectedWeightIdx - 1].Weight = this.state.selectedWeight;
        this.setState({ selectedWeight: '', selectedWeightIdx: (this.state.selectedWeightIdx+1), weights})
      } else {
        this.setState({ selectedWeight: '', selectedWeightIdx: (this.state.selectedWeightIdx+1) }, () => { this.handleFinish(); });
      }
    } else if (event.charCode === 13 && this.state.selectedWeightIdx === 0){
      this.setState({ selectedWeight: '', selectedWeightIdx: (this.state.selectedWeightIdx+1) }, () => { this.handleFinish(); });
    }
  }

  handleChange = (event) => {
    this.setState({ selectedWeight: event.target.value });
  }


  renderWeightsSubmit = () => {
    const confirmWeights = (this.state.selectedWeightIdx === 0) ? <Translate value="press_enter_to_confirm_weights" /> : '';
    return (
      <div>
        <Row style={{ paddingLeft: '50px' }}>
          <h3 style={{ paddingLeft: '18px' }}><Translate value="set_weights" /></h3>
          <Col sm={6}>
            <Input
              type="number"
              addonBefore={this.state.selectedWeightIdx || ''}
              name="selectedWeight"
              autoFocus={!isEcity}
              value={this.state.selectedWeight}
              onChange={this.handleChange}
              disabled={this.state.needsDelete}
              onKeyPress={(event) => {
                this.handleKeyPress(event);
              }}
            />
          </Col>
        </Row>
        <Col><span style={{ color: 'green', paddingLeft: '28px' }}>{confirmWeights}</span></Col>
      </div>
    );
  }

  renderWeightInputs() {
    const { salesOrderLineWeightsIsLoading, salesOrderLineWeightsError } = this.props;
    if (salesOrderLineWeightsIsLoading && !salesOrderLineWeightsError) { return <Spinner className="marginTopStyle" /> }
    else if (salesOrderLineWeightsError) { return (<div className="alert alert-danger">{JSON.stringify(salesOrderLineWeightsError) }</div>); }

    const getRows = () => Data.Selectors.getRows(this.state.weights);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return Object.assign({ Idx: rowIdx+1 }, rows[rowIdx]);
    };

    // Handle the row select function

    const onRowSelect = (rows) => {
      const weights = { ...this.state.weights, rows };
      this.setState({ weights });
    };

    const onRowClick = (rowIdx, row) => {
      this.setState({selectedWeight: row.Weight, selectedWeightIdx: row.Idx});
    };

    const handleRowUpdated = (e) => {
      const rows = getRows();
      const updated = { Weight: parseFloat(e.updated.Weight) };
      Object.assign(rows[e.rowIdx], updated);
      const weights = { ...this.state.weights, rows }
      this.setState({ weights });
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const weights = Object.assign({}, this.state.weights, { sortColumn, sortDirection });
      this.setState({ weights });
    };

    // Custom Formatter component
    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          const date = new Date(this.props.value)
          const index = dateMap.indexOf(date.toString().slice(4, 3));
          const localDate = index + date.toString().slice(8, 6);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    const that = this;
    const deleteFormatter = React.createClass({
      render() {
        return (
          <span>
            <Button
              bsStyle="danger"
              className="textAlignStyle"
              type="button"
              onClick={() => {
                const weights = that.state.weights;
                weights.rows.splice(this.props.dependentValues.Idx - 1, 1);
                const rowsToDelete = that.state.rowsToDelete - 1;
                if (rowsToDelete === 0) {
                  that.setState({ needsDelete: false, rowsToDelete , weights, finished: true });
                } else {
                  that.setState({ rowsToDelete, weights });
                }
              }}
            >X</Button>
          </span>
        );
      },
    });


    // Column difinition
    const ZeroFormatter = React.createClass({
      render() {
        if (this.props.value <= 0 && this.props.dependentValues.zeroFound) { return <div style={{backgroundColor:'yellow'}}>{this.props.value}</div>; }
        return <div>{this.props.value}</div>;
      },
    });

    const columns = [
      {
        key: 'Idx',
        name: <Translate value="idx" />,
        width: 30,
        resizable: false,
        filterable: true,
      },
      {
        key: 'Weight',
        name: <Translate value="weight" />,
        width: 100,
        resizable: true,
        filterable: true,
        editable: true,
        formatter: ZeroFormatter,
        getRowMetaData: row => row,
      },
    ];
    const delColumns = [
      {
        key: 'Idx',
        name: <Translate value="idx" />,
        width: 30,
        resizable: false,
        filterable: true,
      },
      {
        key: 'Weight',
        name: <Translate value="weight" />,
        width: 100,
        resizable: true,
        filterable: true,
      },
      {
        key: 'Delete',
        name: <Translate value="" />,
        width: 60,
        formatter: deleteFormatter,
        getRowMetaData: row => row,
      },
    ];
    return (
      <Row>
        <Col sm={6}>
          <div style={{ maxWidth: '99%' }}>
            {
              (!this.state.needsDelete) ?
                <div id="SetWeightModal-dataGrid1">
                  <ReactDataGrid
                    style={{ height: '10%' }}
                    onGridSort={handleGridSort}
                    columns={columns}
                    enableCellSelect={true}
                    rowHeight={25}
                    rowGetter={rowGetter}
                    rowsCount={getSize()}
                    minHeight={275}
                    onRowClick={onRowClick}
                    onRowUpdated={handleRowUpdated}
                    disable
                  />
                </div> :
                <div id="SetWeightModal-dataGrid2">
                  <span style={{ color: 'red' }}>DELETE {this.state.rowsToDelete} ROW(S)</span>
                  <ReactDataGrid
                    style={{ height: '10%' }}
                    onGridSort={handleGridSort}
                    columns={delColumns}
                    enableCellSelect={true}
                    rowHeight={25}
                    rowGetter={rowGetter}
                    rowsCount={getSize()}
                    minHeight={275}
                    onRowUpdated={handleRowUpdated}
                  />
                </div>
            }
          </div>
        </Col>
        <Col sm={6}>
          <button className="btn btn-primary col-sm-11 buttonStyle" type="button" disabled={this.state.needsDelete} onClick={() => { this.fillWithLastValue(); }}><Translate value="fill_with_latest_value" /></button>
          <br />
          <br />
          <button className="btn btn-danger col-sm-11 buttonStyle" type="button" disabled={this.state.needsDelete} onClick={() => { this.clearAllValues(); }}><Translate value="clear_all_values" /></button>
          <br />
          <br />
          {this.renderWeightsSubmit()}
        </Col>
      </Row>
    );
  }

  openConfirm = () => this.setState({ confirmOpen: true });

  closeConfirm = () => this.setState({ confirmOpen: false, zeroInList: false });

  isZeroWeight = (weights) => {
    let weightChecker = false;
    const zeroRows = { ...this.state.weights };
    for (let i = 0; i < weights.length; i++) {
      if (parseFloat(weights[i].Weight) <= 0) {
        zeroRows.rows[i].zeroFound = true;
        this.setState({ zeroInList: true, weights: zeroRows }, this.openConfirm());
        weightChecker = true;
      }
    }
    this.setState({ zeroInList: false });
    return weightChecker;
  }

  handleFinish = () => {
    if (!this.props.invoice) {
      if (!this.isZeroWeight(this.state.weights.rows)) {
        this.props.setOrderLineWeights(this.props.rowChosen, this.state.weights.rows);
        let totalWeight = 0;
        const rows = [];
        this.state.weights.rows.map((row) => {
          if (row.Weight) {
            totalWeight += parseFloat(row.Weight);
            rows.push(parseFloat(row.Weight));
          }
        });
        this.props.returnTotalWeight(totalWeight.toFixed(4), rows);
        this.setState({ changed: true }, () => { this.props.closeC(); });
      }
    } else {
      if (!this.isZeroWeight(this.state.weights.rows)) {
        this.props.setWeights(this.props.rowChosen, this.state.weights.rows, this.props.editedRow);
        let totalWeight = 0;
        const rows = [];
        this.state.weights.rows.map((row) => {
          if (row.Weight) {
            totalWeight += parseFloat(row.Weight);
            rows.push(parseFloat(row.Weight));
          }
        });
        this.props.returnTotalWeight(totalWeight.toFixed(4), rows);
        this.setState({ changeStyle: true, changed: true }, () => { this.props.closeC(); });
      }
    }
  }

  render() {
    const createDialogStyle = {
      height: '200px',
      marginTop: '-20%',
      width: '300px',
      marginLeft: '-10%',
      left: '45%',
    };
    const confirmAction = (<Translate value="confirm_action" />);
    return (
      <ContentWrapper>
        <hr />
        {this.renderWeightInputs()}
        <br />
        <Row>
          <Col sm={3}><label><Translate value="total_weight" /></label></Col>
          <Col sm={3}>
            <Field
              name='TotalWeight'
              ref='TotalWeight'
              withRef
              onKeyPress={(event) => {
                if (event.charCode == 13 && this.props.totalWeight) {
                  this.handleFinish();
                }
              }}
              component={(!this.state.needsDelete) ? InputField : DisabledInputField}
            />
          </Col>
        </Row>
        <br />
        {
          (!this.props.invoice) ?
            <div>
              <Row>
                <button className="btn btn-primary col-sm-11 buttonStyle" type="button" disabled={this.state.needsDelete} onClick={() => { this.handleFinish(); }}><Translate value="save_weights" /></button>
              </Row>
              <br />
              <Row>
                <button className="btn btn-danger col-sm-11 buttonStyle" type="button" disabled={this.state.needsDelete} onClick={() => { this.props.closeC(); }}><Translate value="discard_changes" /></button>
              </Row>
            </div> :
            <div>
              <Row>
                <button className={(this.state.changeStyle) ? "btn btn-success col-sm-11 buttonStyle" : "btn btn-primary col-sm-11 buttonStyle"} type="button" disabled={this.state.needsDelete} onClick={() => { this.handleFinish(); }}><Translate value="load_weights" /></button>
              </Row>
              <br />
              <Row>
                <button className="btn btn-danger col-sm-11 buttonStyle" type="button" onClick={() => { this.props.closeC(); }}><Translate value="close" /></button>
              </Row>
            </div>
          }
        <br />
        <Row>
          {/*
            {this.props.editSalesOrderLineWeightsError &&
            <div className="alert alert-danger">{this.props.editSalesOrderLineWeightsError}</div>}
            { (!this.props.invoice) ?
              <div>
                {this.props.salesOrderLineWeightsIsEditing &&
                <div className="alert alert-info"><Translate value="uploading" /></div>}
                {this.props.editSalesOrderLineWeightsSuccess &&
                <div className="alert alert-success"><Translate value="saved" /></div>}
              </div> :
              <span></span>
            }
          */}
        </Row>
        <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.confirmOpen} onCloseClicked={() => { this.closeConfirm(); }} title={confirmAction}>
          <ConfirmActionModal case={this.state.case} closeC={this.closeConfirm} />
        </SkyLightStateless>
      </ContentWrapper>
    );
  }
}

export default SetWeightModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Dispatch/setWeightModal.jsx